export * from './reminder-full-page/reminder-full-page.component';
